/*global PNotify:true*/

angular.module('b2bLoginApp.services').factory('Notification', ["Translator", function(Translator) {
    var width = Math.min(500, $('body').innerWidth()-30);

    var stack = {
        'dir1':'down',
        'dir2':'right',
        'push':'top',
        'spacing1': 0,
        'spacing2': 25,
        'firstpos1': 100,
        'firstpos2': (($('body').innerWidth() / 2) - width / 2)
    };

    var timeout = false;

    $(window).resize(function() {
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            stack.firstpos2 = (($('body').innerWidth() / 2) - width / 2);
        }, 250);
    });

    var opts = {
        title:       null,
        text:        null,
        width:       width+'px',
        addclass:    'sd-pnotify',
        stack:       stack,
        type:        'info',
        mouse_reset: false,
        shadow:      true,
        icon:        false,
        hide:        true,
        buttons: {
            closer_hover: false,
            sticker: false
        },
        animate_speed: 250,
        position_animate_speed: 100
    };

    function createNotice(opts) {
        var notice = new PNotify(opts);
        notice.get().click(function(){
            notice.remove();
        });
    }

    return {
        message: function(title, text) {
            opts.title = title;
            opts.text  = Translator.trans(text);
            opts.type  = 'alert-primary';
            createNotice(opts);
        },
        success: function(title, text) {
            opts.title = title;
            opts.text  =  Translator.trans(text);
            opts.type  = 'alert-success';
            createNotice(opts);
        },
        error: function(title, text) {
            opts.title = title;
            opts.text  =  Translator.trans(text);
            opts.type  = 'alert-danger';
            opts.hide  = false;
            createNotice(opts);
        },
        closeAll: function() {
            PNotify.removeAll();
        },
        getStack: function() {
            return stack;
        }
    };
}]);
